import { Link } from '@mui/material';
import MailOutlinedIcon from '@mui/icons-material/MailOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';

import { useTranslation } from '../../context/TranslationContext.jsx';

import { DetailIcon, DetailRow, ManufacturerName } from './styles.js';

const SUPPORT_EMAIL = 'support@reyedar.com';

const ManufacturerInformation = ({ variant }) => {
  const { translate } = useTranslation();

  return (
    <>
      <ManufacturerName displayVariant={variant}>Reyedar B.V.</ManufacturerName>
      <DetailRow>
        <DetailIcon displayVariant={variant}>
          <PlaceOutlinedIcon />
        </DetailIcon>
        <span>{translate('authPage.legal.manufacturerAddress')}</span>
      </DetailRow>
      <DetailRow>
        <DetailIcon displayVariant={variant}>
          <MailOutlinedIcon />
        </DetailIcon>
        <span>
          <Link href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</Link>
        </span>
      </DetailRow>
    </>
  );
};

export default ManufacturerInformation;
